/* Sapone Di Toscana — winkelwagen
 * <sdt-cart-reco>: vervangt de terugvalkeuze (collectie 'uitgelicht') door een passende aanbeveling van Shopify
 *   (/recommendations/products, eerst 'complementary', dan 'related') en onthoudt het resultaat per mandinhoud.
 *   De drawer wordt na elke wijziging opnieuw gerenderd; dezelfde mandinhoud geeft dan direct het opgeslagen resultaat
 *   (geen extra verzoek, geen flikkering). Toevoegen gaat via [data-quick-add] → SDTLux.addToCart (sdt-lux.js).
 * <sdt-cart-sticky>: compacte afrekenbalk op /cart (mobiel), alleen zichtbaar als de gewone knop niet in beeld is.
 */
(function () {
  'use strict';

  if (!customElements.get('sdt-cart-reco')) {
    var cache = new Map(); // mandsleutel -> Promise<html|null>
    var refocus = false;

    function fetchSlot(base, productId, intent) {
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      var url = base + sep + 'section_id=sdt-cart-reco&limit=6&intent=' + intent + '&product_id=' + encodeURIComponent(productId);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (text) {
          if (!text) return null;
          var slot = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-sdt-reco-slot]');
          return slot && slot.dataset.source === 'reco' ? slot.innerHTML : null;
        });
    }

    function getPick(key, base, productId) {
      if (cache.has(key)) return cache.get(key);
      var p = fetchSlot(base, productId, 'complementary')
        .then(function (html) { return html || fetchSlot(base, productId, 'related'); })
        .catch(function () { cache.delete(key); return null; });
      cache.set(key, p);
      return p;
    }

    // Na "+ Toevoegen" wordt de hele drawer vervangen; zet de focus daarna op een logische plek.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.sdt-reco__add')) {
        refocus = true;
        setTimeout(function () { refocus = false; }, 5000);
      }
    }, true);

    customElements.define('sdt-cart-reco', class SdtCartReco extends HTMLElement {
      connectedCallback() {
        var self = this;
        var key = this.dataset.key;
        var productId = this.dataset.productId;
        var base = this.dataset.url || (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
        if (refocus) { refocus = false; this.restoreFocus(); }
        if (!key || !productId) return;
        getPick(key, base, productId).then(function (html) {
          if (html && self.isConnected) self.apply(html);
        });
      }

      apply(html) {
        var slot = this.querySelector('[data-sdt-reco-slot]');
        if (!slot || slot.dataset.source === 'reco') return;
        var hadFocus = slot.contains(document.activeElement);
        slot.innerHTML = html;
        slot.dataset.source = 'reco';
        this.hidden = false;
        if (hadFocus) { var b = slot.querySelector('.sdt-reco__add'); if (b) b.focus(); }
      }

      restoreFocus() {
        var self = this;
        requestAnimationFrame(function () {
          var drawer = document.querySelector('cart-drawer');
          var target = (!self.hidden && self.querySelector('.sdt-reco__add')) || document.getElementById('CartDrawer-Checkout') || document.getElementById('checkout');
          if (!target) return;
          if (drawer && typeof trapFocus === 'function') trapFocus(drawer, target);
          else target.focus();
        });
      }
    });
  }

  if (!customElements.get('sdt-cart-sticky')) {
    customElements.define('sdt-cart-sticky', class SdtCartSticky extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.footer = document.getElementById('main-cart-footer');
        this.visibleMain = true;
        this.update = this.update.bind(this);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            self.visibleMain = entries[0].isIntersecting;
            self.update();
          });
          this.observeMain();
        }
        // Subtotaal en knop van de pagina wisselen na elke wijziging; balk volgt mee.
        if (this.footer && 'MutationObserver' in window) {
          this.mo = new MutationObserver(function () { self.observeMain(); self.syncTotal(); self.update(); });
          this.mo.observe(this.footer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        }
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.update);
        this.update();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.mo) this.mo.disconnect();
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.update);
        document.body.classList.remove('sdt-has-cart-sticky');
      }

      observeMain() {
        var btn = document.getElementById('checkout');
        if (!this.io || !btn || btn === this.mainBtn) return;
        if (this.mainBtn) this.io.unobserve(this.mainBtn);
        this.mainBtn = btn;
        this.io.observe(btn);
      }

      syncTotal() {
        var src = this.footer && this.footer.querySelector('.sdt-sum__value');
        var dst = this.querySelector('.sdt-cart-sticky__total strong');
        if (src && dst && dst.innerHTML !== src.innerHTML) dst.innerHTML = src.innerHTML;
      }

      update() {
        var empty = this.footer && this.footer.classList.contains('is-empty');
        var show = this.mq.matches && !this.visibleMain && !empty && !!this.mainBtn;
        this.hidden = !show;
        // Ruimte onderaan zodat de balk geen inhoud afdekt.
        document.body.classList.toggle('sdt-has-cart-sticky', this.mq.matches && !empty && !!this.mainBtn);
      }
    });
  }
})();
